import { fieldRef, op } from './astHelpers';

/**
 * Subtract fields: SUBTRACT(first, rest...)
 * Uses subtractFieldCodes: [minuend, ...subtrahends]
 * Or minuendFieldCode + sumFieldCodes as subtrahends.
 */
export const buildSubtractFormula = (cfg = {}) => {
  let codes = Array.isArray(cfg.subtractFieldCodes) ? cfg.subtractFieldCodes.filter(Boolean) : [];
  if (!codes.length && cfg.minuendFieldCode) {
    const subs = Array.isArray(cfg.sumFieldCodes) ? cfg.sumFieldCodes.filter(Boolean) : [];
    codes = [cfg.minuendFieldCode, ...subs];
  }
  if (codes.length < 2) return null;
  return op('SUBTRACT', codes.map(fieldRef));
};
